module.exports = __webpack_public_path__ + "static/media/sss-auto-minus.e2ba0c0b.svg";